import React from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import './BimHeader.css';

class BimHeader extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      searchString: ""
    }
    this.updateSearch = this.updateSearch.bind(this);
  }

  updateSearch(e){
    this.setState({searchString: e.target.value});
    this.props.updateSearch(e.target.value);
  }

  render(){
    return (
    	<div className="projectsHeaderWrapper">
      		<div className="projectsHeaderText">
          BIM Models
          </div>
          <div className="projectsHeaderSearch">
            <InputGroup className="projectsHeaderSearchNew" id="projectsHeaderSearchNew">
              <InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1">Search:</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                placeholder=""
                aria-label=""
                aria-describedby="basic-addon1"
                value={this.state.searchString}
                onChange={this.updateSearch}
              />
            </InputGroup>
          </div>
      </div>
    );
  }
}

export default BimHeader;